export default __webpack_public_path__ + "static/media/a018-3.e353da15.svg";